import { Controller } from "@hotwired/stimulus"

/**
 * Nested Fields Controller
 * Generic controller for handling nested form field removal with _destroy pattern.
 */
export default class extends Controller {
  static targets = ["destroyField"]

  /**
   * Remove the nested field row
   * - For persisted records: marks _destroy field as true and hides the row
   * - For new records: removes the row entirely
   */
  remove(event) {
    event.preventDefault()

    const row = this.element

    if (this.hasDestroyFieldTarget) {
      // Persisted record - mark for destruction
      this.destroyFieldTarget.value = "true"

      // Hide with animation
      row.style.opacity = "0.5"
      row.style.transform = "scale(0.98)"
      row.style.transition = "all 0.2s ease-out"

      setTimeout(() => {
        row.style.display = "none"
        // Dispatch event for parent controller to update totals
        this.dispatch("removed")
      }, 200)
    } else {
      // New record - remove entirely with animation
      row.style.opacity = "0.5"
      row.style.transform = "scale(0.95)"
      row.style.transition = "all 0.2s ease-out"

      setTimeout(() => {
        row.remove()
        // Dispatch event for parent controller to update totals
        this.dispatch("removed")
      }, 200)
    }
  }
}
